module.exports = __webpack_public_path__ + "static/pools-header-28e4a5f73042340efda2f3b2612788ab.png";